import { render, staticRenderFns } from "./guidelines-cmp.vue?vue&type=template&id=781ae17f&scoped=true"
import script from "./guidelines-cmp.vue?vue&type=script&lang=js"
export * from "./guidelines-cmp.vue?vue&type=script&lang=js"
import style0 from "./guidelines-cmp.vue?vue&type=style&index=0&id=781ae17f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781ae17f",
  null
  
)

export default component.exports